import camelcaseKeys from 'camelcase-keys';
import type { CamelCasedPropertiesDeep } from 'type-fest';

export type Camelized<T> = CamelCasedPropertiesDeep<T>;

export type CamelizeOptions = {
  /** Caminhos com os nomes originais, em notação de ponto e sem índice de array, cujos filhos ficam como vieram. */
  stopPaths?: readonly string[];
};

export function camelize<T extends Record<string, unknown> | readonly unknown[]>(input: T, options?: CamelizeOptions): Camelized<T>;
export function camelize<T extends Record<string, unknown> | readonly unknown[]>(input: T | null | undefined, options?: CamelizeOptions): Camelized<T> | null | undefined;
export function camelize<T extends Record<string, unknown> | readonly unknown[]>(input: T | null | undefined, options: CamelizeOptions = {}): Camelized<T> | null | undefined {
  // Cast explícito: com `strictNullChecks` o narrowing já entrega `null | undefined`, mas sem ele
  // `input` continua `T` e o retorno não compila. O cast deixa a passagem de nulo válida nos dois.
  if (input == null) return input as null | undefined;
  return camelcaseKeys(input as never, { deep: true, stopPaths: options.stopPaths }) as Camelized<T>;
}
